module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bubble-logo-d45fe3e13c252321b410ce60b2feb488.svg";